<template>
	<div class="pl-4 pr-4 pb-2" style="height: 100%">
		<div v-if="room_instance" id="notes-wrapper">
			<v-textarea rows="1" filled v-model="newNote" placeholder="..." v-on:keyup.enter="saveNote"></v-textarea>
			<div id="notes" ref="notes">
				<p class="overline">
					<span class="roomTime">Room started at {{ room_instance.created.toDate() | moment("DD/MM/YYYY, HH:mm") }}</span>
				</p>
				<p v-for="note in notes" :key="note.id" class="mb-0"> 
					<span class="note-content">{{note.content}}</span><br/>
					<span class="roomTime">{{ note.created.toDate() | moment("HH:mm:ss") }}</span> &nbsp;
					<span class="timeSince">[{{ timeSinceRoomStart(note.created) }}]</span>
				</p>
			</div>
				<v-btn id="dl-button" x-small @click="dl" color="primary">Download</v-btn>
		</div>
	</div>
</template>

<style lang="less">
	#notes{
		overflow: hidden;
		overflow-y: scroll;
		height: 50%
	}

	#notes-wrapper{
		height: 96%;
		position: relative;
	}
	.note-content {
		font-size: 0.8em !important; 
	}
	.roomTime {
		color: darkgrey;
		font-size: 0.7em;
	}
	.timeSince {
		color: navy;
		font-size: 0.7em;
	}
	#dl-button{
		position: absolute;
		bottom: 10px;
		right: 10px;
	}
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import Vue from "vue";
	// import - from "@/components/"
	export default {
		name: "TimeStampNotes", 
		props: {
			twilioObject: {}
		},
		data: () => {
			return {
				newNote: ""
			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user,
				video_room: state => state.video,
				room_instance: state => state.video.roomInstance, 
				participant: state => state.video.participant,
				participantNotes: state => state.video.participantNotes
			}),
			notes(){
				var r = this.room_instance.id;
				return this.participantNotes.filter( n => n.roomInstance == r )
			}
		},
		methods: {
			dl(){
				var elHtml = this.$refs.notes.innerText;
				var link = document.createElement('a');
				var fileName = this.video_room.projectName+" notes.txt";
				link.setAttribute('download', fileName);
				link.setAttribute('href', 'data:text/plain'  +  ';charset=utf-8,' + encodeURIComponent(elHtml));
				link.click(); 
			},
			timeSinceRoomStart(date){
				if( !this.room_instance ){
					return;
				}
				var start = Vue.moment( this.room_instance.created.toDate() ); //todays date
				var end = Vue.moment( date.toDate() ); // another date
				var duration = Vue.moment.duration(end.diff(start));
				var secondsSince = duration.asSeconds();
				var minutes = Math.floor(secondsSince / 60);
				var seconds = secondsSince - minutes * 60;
				seconds =  Math.floor(seconds);
				if( seconds < 10 ){
					seconds = "0" + seconds;
				}
				return minutes + ":" + seconds
			},
			saveNote(){
				const self = this;
				var note = {
					content: self.newNote,
					roomInstance: self.room_instance.id,
				}
				self.$store.dispatch("addDoc", {
					collection: "videoRooms/" + self.video_room.id + "/participants/" + self.user.uid + "/notes", 
					data: note
				}).then(() => {
					self.newNote = ""
				})
			}
		},
		created(){
			this.$store.dispatch("video/fetchParticipantNotes");			
		}

	}
// </script>"